import React from 'react'
import { Banner, Button, Text } from '@fielded/shared-ui'
import { ExclamationTriangle, Refresh } from '@fielded/shared-ui/src/icons'

const reloadWindow = () => {
  window.location.reload()
}

/**
 * We intentionally do not destructure or display the error prop here.
 * Error details are already captured and monitored through Sentry,
 * so users only see a generic retry experience instead of raw technical errors.
 */
const InitialLoadingError = (props) => {
  return (
    <section>
      <Banner
        title='Something went wrong while Downloading your data'
        type='warning'
        icon={<ExclamationTriangle />}
        inline
      >
        <Text className='vs-u-margin-bottom-half'>Check your connection and try again</Text>
        <Button
          colorVariant='brand'
          fill='full'
          icon={<Refresh direction='left' />}
          onClick={reloadWindow}
        >
          Retry
        </Button>
      </Banner>
    </section>
  )
}

export default InitialLoadingError
